import _kebabCase from 'lodash/kebabCase'

export default _kebabCase



// WEBPACK FOOTER //
// ./src/utils/slugify.js